 <div class="message-center-container-box" id="message-center-container-box"
    [class.message-center-container-box--open]="menuOpen"
  >
    <div class="message-center-container-box__triangle" id="message-center-container-box__triangle"></div>
    <div class="message-center-container-box__menu" id="message-center-holder">
        @if (menuOpen) {
          @for (key of [messageHubKey]; track key) {
        <rcg-message-hub
          [language]="language"
          [brand]="brand"
          [apiConfig]="apiConfig"
          [analyticsClientData]="analyticsClientData"
          (customErrorEvent)="customErrorEvent($event)"
          (notificationClickEmitter)="notificationClickEmitter($event)"
        ></rcg-message-hub>
            }
        }
      </div>
    </div>